import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Inject,
    Input,
    Optional,
    Output,
} from '@angular/core';
import { Observable } from 'rxjs';

import {
    CoachingType,
    GoalStatus,
    OpportunityStatus,
} from '../../../coaching-base/general';
import { OpportunityType } from '../../../coaching-base/opportunity';
import { actions, addPageAction } from '../../../coaching/new-relic';
import { WidgetConfiguration } from '../../../widget/config.widget.model';
import { CMPS_WIDGET_CONFIG } from '../../../widget/widget.metadata';
import { TranslationKeyMap } from '../../coaching-insight.i18n';
import { OldOaWidgetTypeId } from '../../coaching-insight.module';
import { getUniqueFromSet } from '../models/coaching.global.model';
import { Goal, Opportunity } from '../models/oa.model';
import { TeamOAService } from '../services/team-oa.service';

import { GoalScoreComponent } from './goal-score.component';

@Component({
    selector: 'metric-button',
    templateUrl: './metric-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [GoalScoreComponent],
})
export class MetricButtonComponent {
    @Input() opportunity: Opportunity;
    @Input() withTooltip: boolean = true;
    @Input() disableClick: boolean = false;

    @Output() clicked: EventEmitter<Opportunity> =
        new EventEmitter<Opportunity>();

    activeMetric: Observable<Opportunity>;
    /** @private */ _GoalStatus = GoalStatus;

    goal: Goal;
    coachedComponents: Opportunity[];

    OpportunityType = OpportunityType;

    i18n = TranslationKeyMap;

    OpportunityStatus = OpportunityStatus;
    CoachingType = CoachingType;

    constructor(
        private readonly _teamOAService: TeamOAService,
        @Optional()
        @Inject(CMPS_WIDGET_CONFIG)
        private readonly _config: WidgetConfiguration,
    ) {}

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnInit() {
        this.activeMetric = this._teamOAService.activeMetric;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    getTooltip(tooltip: any) {
        const opp = this.opportunity;

        if (!opp || !tooltip) return;

        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        const comms =
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            opp.commitments && opp.commitments.length
                ? opp.commitments.filter((y) => y.goals && y.goals.length > 0) // for primary metric, only get the first commitment
                : [];

        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (opp.coachedComponents && opp.coachedComponents.length) {
            let eachcomponentcommitment = [];

            opp.coachedComponents.forEach((cc) => {
                const c = cc.commitments.filter(
                    (h) => h.statusId === GoalStatus.ACTIVE,
                );
                eachcomponentcommitment.push(...c);
            });
            eachcomponentcommitment = getUniqueFromSet(
                eachcomponentcommitment,
                'commitmentId',
            );
            comms.push(...eachcomponentcommitment);
        }

        tooltip.open({
            opportunity: opp,
            comms,
            coachedComponents: opp.coachedComponents,
        });
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    setMetric() {
        addPageAction(actions.OpportunityAlignment.OPPORTUNITY_METRIC_CLICK, {
            userId: this.opportunity?.userId,
            metricId: this.opportunity?.metricId,
            coachingTypeId: this.opportunity?.coachTypeId,
            oldOaWidget: this._config?.typeId === OldOaWidgetTypeId,
        });

        this.clicked.emit(this.opportunity);

        if (this._config && this._config.typeId === OldOaWidgetTypeId) {
            this._teamOAService.setActiveMetric(this.opportunity);
        }
    }
}
